module.exports = __webpack_public_path__ + "img/rcyc-sqlc.c1db82fa.png";